export default __webpack_public_path__ + "static/media/sip-picturemark-d.2ad4f6e3.svg";